import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent, LoadingService } from 'core';
import { TranslationService } from 'dhofar-shared-pkg';
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoadingComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  isLoading = true;
  title = 'DhofarCmsFrontend';
  private loadingService = inject(LoadingService);
  private localize = inject(TranslationService);
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.localize.initLanguage();
    this.loadingService.isLoading$.subscribe(isLoading => setTimeout(() => (this.isLoading = isLoading)));
  }
}
